import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedCollections from "./components/FeaturedCollections";
import BigTimeline from "./components/BigTimeline";
import FeaturedArticles from "./components/FeaturedArticles";
import FaqSection from "./components/FaqSection";
import CtaBand from "./components/CtaBand";
import { faqList } from "@/mocks/home";

const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "蝌蚪黑料",
      url: "https://bhmbk.cn/",
      description: "全网热门事件合集与瓜料追踪平台，按话题整理事件脉络与后续更新。",
    },
    {
      "@type": "Organization",
      name: "蝌蚪黑料",
      url: "https://bhmbk.cn/",
      email: "hello@kedou-heiliao.example.com",
      description: "内容整理与话题追踪平台",
    },
    {
      "@type": "FAQPage",
      mainEntity: faqList.map((f) => ({
        "@type": "Question",
        name: f.question,
        acceptedAnswer: { "@type": "Answer", text: f.answer },
      })),
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Navbar />
      <main className="flex-1">
        <Hero />
        <HotBoard />
        <CategoryGrid />
        <FeaturedCollections />
        <BigTimeline />
        <FeaturedArticles />
        <FaqSection />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}